import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Stack,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import DownloadIcon from "@mui/icons-material/Download";
import * as XLSX from "xlsx";

import PageButtonWhite from "../GeneralComponents/PageButtonWhite";
import InputFilter from "../GeneralComponents/InputFilter";
import InputFile from "../GeneralComponents/InputFile";


export default function GenericTextList({
  title = "Listado",
  columns = [],
  filtersConfig = [],
  dataSource, 
  api,
  selectable = true,
  breadcrumb,
}) {

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({});
  const [tableData, setTableData] = useState([]);

  const [page, setPage] = useState(0);
  const [rpp, setRpp] = useState(10);

  const [selected, setSelected] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        setLoading(true);
        let data = [];
        if (typeof dataSource === "function") {
          data = await dataSource();
        } else if (typeof api === "string" && api.length > 0) {
          const resp = await fetch(api);
          data = (resp.ok ? await resp.json() : []) || [];
        }
        if (alive) {
          const normalized = data.map((r, idx) => ({
            id: r.id ?? idx,
            index: idx,
            ...r,
          }));
          setRows(normalized);
          setTableData(normalized);
          setSelected([]);
          setPage(0);
        }
      } catch (e) {
        if (alive) {
          console.error("Error cargando datos:", e);
          setRows([]);
          setTableData([]);
          setSelected([]);
          setPage(0);
        }
      } finally {
        if (alive) setLoading(false);
      }
    };
    load();
    return () => {
      alive = false;
    };
  }, [dataSource, api]);

  const applyFilters = (nextFilters, baseRows = rows) => {
    const activeEntries = Object.entries(nextFilters).filter(
      ([, val]) => val != null && String(val).length > 0
    );

    const filtered =
      activeEntries.length === 0
        ? baseRows
        : baseRows.filter((row) =>
            activeEntries.every(([key, val]) => String(row[key] ?? "") === String(val))
          );

    setTableData(filtered);
    setSelected([]);
    const maxPage = Math.floor(Math.max(filtered.length - 1, 0) / rpp);
    if (page > maxPage) setPage(0);
  };

  const handleFilter = (item, value) => {
    const nf = { ...filters, [item]: value };
    if (value == null || String(value).length === 0) {
      delete nf[item];
    }
    setFilters(nf);
    applyFilters(nf);
  };

  const isSelected = (idx) => selected.includes(idx);
  const handleSelectAll = (e) => {
    if (!selectable) return;
    setSelected(e.target.checked ? tableData.map((r) => r.index) : []);
  };
  const handleCheckboxClick = (idx) => {
    if (!selectable) return;
    setSelected((prev) =>
      prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
    );
  };

  const downloadXLS = () => {
    const selectedRows = tableData.filter((row) => selected.includes(row.index));
    const prepared = selectedRows.map((row) => {
      const obj = {};
      columns.forEach((c) => {
        obj[c.label] = row[c.id] ?? "";
      });
      return obj;
    });
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(prepared);
    XLSX.utils.book_append_sheet(wb, ws, "Tabla");
    XLSX.writeFile(wb, (title || "tabla") + ".xlsx");
  };


    const [evError, setEvError] = useState(false);


  const [reportFile, setReportFile] = useState();
  const setFile = (archivo) => {
    setEvError(!archivo ? true : false);
    setFile((prevData) => ({
      ...prevData,
      archivo,
    }));
  };

  return (
    <>

      {filtersConfig.length > 0 && (
        <Grid
          container
          spacing={0}
          sx={{ m: 0, p: 0 }}
          alignItems="flex-start"
        >
          <Grid size={12}>
            <Grid container spacing={1} sx={{ mb: 2 }}>
              {filtersConfig.map(({ item, name, size = 6, opt, defaultOpt }) => (
                <Grid key={item} size={size}>
                  <InputFilter
                    data={rows}
                    item={item}
                    name={name}
                    callback={handleFilter}
                    opt={opt}
                    defaultOpt={defaultOpt}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      )}

      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="40vh">
          <CircularProgress />
        </Box>
      ) : (
        <>

               {title === "OTROS REPORTES" ? ( <Paper sx={{ mb: 2, p: 1.25, textAlign: "center" }}>

       <Box sx={{ p: "2rem 9rem", textAlign: "center" }}> 

        

         {breadcrumb ? (
          <Box sx={{ display: "inline-block", textAlign: "center"}}>
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", textAlign: "center", fontSize: "1.08rem", lineHeight: 1.2 }}
            >
              {breadcrumb}
            </Typography>
            <Box
              sx={{
                width: "100%",
                borderBottom: "1px solid #111",
                mt: 0.75,     
              }}
            />
          </Box>
        ) : null}

        <Stack  alignItems="left" justifyContent="center" spacing={2}>
               

                    <Typography
                        variant="h1"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, textAlign: "center", fontWeight: 700 }}
                    >
                        OTROS REPORTES
                    </Typography>

                            <Box 
          justifyContent="center"
          sx={{ maxWidth: "100%", margin: "0 auto", display: "flex" }}
        >
          <Typography
            variant="body"
            align="center"
            sx={{ marginBottom: "2rem" }}
          >
                  En el siguiente campo cargue el archivos con la información que necesite reportar para dejar en los registros.
                  </Typography>
        </Box>
        </Stack>
        <Grid container spacing={2}>
        <Grid size={12}>
              <Box>
                <InputFile
                  onFileSelect={setFile}
                  fileType="pdf"
                  placeholder="Oficio recepción de obras"
                  buttonText="Subir archivo"
                  sizeBtnGrid={4}
                />
                <Typography
                  variant="small"
                  align="left"
                  sx={{
                    marginBottom: "18px",
                    color: evError ? "red" : "#111",
                  }}
                >
                  {evError ? "Debe adjuntar evidencia" : ""}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          </Box>
       </Paper>) : null}

      <Paper sx={{ mb: 2, p: 1.25, textAlign: "center" }}>
        {breadcrumb && title !== "OTROS REPORTES" ? (
          <Box sx={{ display: "inline-block", textAlign: "center", mt: 2 }}>
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", textAlign: "center", fontSize: "1.08rem", lineHeight: 1.2 }}
            >
              {breadcrumb}
            </Typography>
            <Box
              sx={{
                width: "100%",
                borderBottom: "1px solid #111",
                mt: 0.75,     
              }}
            />
          </Box>
        ) : null}

        <Typography
          variant="h1"
          color="inherit"
          noWrap
          sx={{ textAlign: "center", p: "0.5rem" }}
        >
          {title} {title === "OTROS REPORTES" ? "ANTERIORES" : ""}
        </Typography>

      </Paper>





          <TableContainer component={Paper} variant="outlined">
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  {selectable && (
                    <TableCell align="left" sx={{ width: 48 }}>
                      <Checkbox
                        indeterminate={
                          selected.length > 0 && selected.length < tableData.length
                        }
                        checked={
                          tableData.length > 0 && selected.length === tableData.length
                        }
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                  )}
                  {columns.map((col) => (
                    <TableCell
                      key={col.id}
                      align={col.align || "left"}
                      sx={{ minWidth: col.minWidth }}
                    >
                      {col.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {tableData
                  .slice(page * rpp, page * rpp + rpp)
                  .map((row) => (
                    <TableRow
                      key={row.id}
                      hover={!!selectable}
                      selected={isSelected(row.index)}
                    >
                      {selectable && (
                        <TableCell>
                          <Checkbox
                            checked={isSelected(row.index)}
                            onClick={() => handleCheckboxClick(row.index)}
                          />
                        </TableCell>
                      )}
                      {columns.map((col) => (
                        <TableCell key={col.id} align={col.align || "left"}>
                          {row[col.id] ?? ""}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            {tableData.length === 0 && (
              <Box sx={{ py: 6, textAlign: "center", color: "text.secondary" }}>
                Sin datos
              </Box>
            )}
            <TablePagination
              component="div"
              rowsPerPageOptions={[10, 25, 100]}
              count={tableData.length}
              rowsPerPage={rpp}
              page={page}
              onPageChange={(_, p) => setPage(p)}
              onRowsPerPageChange={(e) => {
                setRpp(parseInt(e.target.value, 10));
                setPage(0);
              }}
            />
          </TableContainer>

          {selectable && (
            <Grid container spacing={2} justifyContent="flex-end" sx={{ pt: 2 }}>
              <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                <PageButtonWhite onClick={downloadXLS} width="100%" disabled={selected.length === 0}>
                  Descargar selección (.xls)
                </PageButtonWhite>
              </Grid>
            </Grid>
          )}
        </>
      )}
    </>
  );
}
